<app-component-wrapper class="w-50 flex-fill" compclass="flex-fill h-100" id="current-employer-container">
  <div class="d-flex flex-column flex-fill" slot="start">
    <div id="consolidate-super-container">
      <div class="d-flex flex-column">
        <div class="header">
        </div>
        <div class="bg"></div>
        <div class="d-flex align-items-center info flex-column ">
          <div class="work">
            <mat-icon>work</mat-icon>
          </div>
          <div *ngIf="employer$ | async; let employer;"class="flex-fill d-flex flex-column align-items-center w-100 ps-2 pe-2">
            <h3 class="title mt-2">{{employer.employerName}}</h3>
            <div class="d-flex flex-row  flex-fill w-100 items">
              <div class="align-items-center d-flex w-100 badge badge-light p-3 m-1 ">
                <div class="d-flex flex-column align-items-center w-100">
                  <mat-icon class="">person</mat-icon>
                  <div class="title">Number</div>
                  <div class="value">{{employer.payrollNumber}}</div>
                </div>
              </div>
              <div class="align-items-center d-flex w-100 badge badge-light p-3 m-1 ">
                <div class="d-flex flex-column align-items-center w-100">
                  <mat-icon class="">event</mat-icon>
                  <div class="title">Joined</div>
                  <div class="value">{{employer.joinDate | date:'dd/MM/yyyy'}}</div>
                </div>
              </div>
              <div class="align-items-center d-flex w-100 badge badge-light p-3 m-1 ">
                <div class="d-flex flex-column align-items-center w-100">
                  <mat-icon class="">event</mat-icon>
                  <div class="title">Last contribution</div>
                  <div class="value">{{employer.lastContribution | date:'dd/MM/yyyy'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</app-component-wrapper>
